import { render, staticRenderFns } from "./cobranca.vue?vue&type=template&id=5396337e&"
import script from "./cobranca.vue?vue&type=script&lang=js&"
export * from "./cobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports